/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 用户状态
 */
let EnumAuthStatus = {
	Normal             : new EnumItem('授权', 0),
    Stop               : new EnumItem('未授权', 2),
	...enumMixn
}
export default EnumAuthStatus
